import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

interface BodyProps {
  chatRoomName: string;
  isAiSnoozed?: boolean;
  isDirect: boolean;
  isUnread?: boolean;
  lastMessage: any;
  timestamp: string;
}
export const Body = ({
  isDirect,
  chatRoomName,
  timestamp,
  lastMessage,
  isUnread,
  isAiSnoozed,
}: BodyProps) => {
  const { sender, body } = lastMessage;
  const messageSenderName = isDirect ? "" : `${sender?.name}: `;
  const messageBody = body?.circle_ios_fallback_text || "";

  return (
    <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex items-center justify-between gap-2">
        <Typography
          variant="heading-sm"
          color="primary"
          truncate
          className="min-w-0"
        >
          {chatRoomName}
        </Typography>
        <div className="flex h-5 min-w-fit items-center justify-center gap-x-1.5">
          {isAiSnoozed && (
            <Icon name="clock-snooze" size="sm" color="secondary" />
          )}
          {isUnread && (
            <span className="bg-royal-blue-400 inline-block size-2 rounded-full" />
          )}
        </div>
      </div>
      <div className="flex w-full items-center justify-between gap-2">
        <Typography
          variant="body-sm"
          color="tertiary"
          truncate
          className="min-w-0 flex-1 text-left"
        >
          {`${messageSenderName}${messageBody}`}
        </Typography>
        <Typography variant="caption" color="tertiary" className="shrink-0">
          {timestamp}
        </Typography>
      </div>
    </div>
  );
};
